module.exports = __webpack_public_path__ + "static/media/icon-lock.a9145d24.svg";